import React from 'react'

import { useModal } from '@/contexts/ModalContext'

import { useTranslation } from 'react-i18next'

import * as S from './styles'

const videoContent = '/assets/videos/teaser.mp4'

export interface NewContentModalConfig {
  registerUserAnswer: () => void
}

export interface NewContentModalProps {
  config: NewContentModalConfig
}

const NewContentModal = ({ config }) => {
  const { t } = useTranslation()
  const { closeModal } = useModal()

  const closeContent = () => {
    closeModal()
    config.registerUserAnswer()
  }

  return (
    <S.NewContentModalWrapper>
      <h3>{t('messages.newContentTitle')}</h3>
      <S.VideoWrapper>
        <video controls muted autoPlay>
          <source src={videoContent} type="video/mp4" />
        </video>
      </S.VideoWrapper>
      <p id="subtitle">{t('messages.newContentSubtitle')}</p>
      <p id="text">{t('messages.newContentText')}</p>
      <button onClick={closeContent}>{t('messages.newContentClose')}</button>
    </S.NewContentModalWrapper>
  )
}

export default NewContentModal
